module.exports = __webpack_public_path__ + "img/thumbnail_RedKangaroo_m_albino.8a57e48d.png";